import { render, staticRenderFns } from "./StockDebtPayment.vue?vue&type=template&id=35076142"
import script from "./StockDebtPayment.vue?vue&type=script&lang=js"
export * from "./StockDebtPayment.vue?vue&type=script&lang=js"
import style0 from "./StockDebtPayment.vue?vue&type=style&index=0&id=35076142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports